import {
    HttpInterceptor,
    HttpRequest,
    HttpEvent,
    HttpHandler,
    HttpParams,
    HttpParameterCodec,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class EncodeHttpParamsInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const params = new HttpParams({
            encoder: new CustomEncoder(),
            fromString: req.params.toString(),
        });
        return next.handle(req.clone({ params }));
    }
}

class CustomEncoder implements HttpParameterCodec {
    constructor() {}

    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    encodeValue(value: string): string {
        return encodeURIComponent(value);
    }

    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}

export default class CustomUrlSerializer implements UrlSerializer {
    private _defaultUrlSerializer: DefaultUrlSerializer =
        new DefaultUrlSerializer();

    parse(url: string): UrlTree {
        // Encode "+" to "%2B"
        // url = url.replace(/\=/gi, '_');
        // Use the default serializer.
        return this._defaultUrlSerializer.parse(url);
    }

    serialize(tree: UrlTree): string {
        console.log('>>>', this._defaultUrlSerializer.serialize(tree));

        return encodeURIComponent(this._defaultUrlSerializer.serialize(tree));
        // return this._defaultUrlSerializer.serialize(tree)//.replace(/\=/gi, '_');
    }
}
